module.exports = __webpack_public_path__ + "img/motoacquaWhite.fa8d1990.svg";